import React from "react";
import P from "../Paragraph";
import Btn from "../Button";

interface BulkActionBarProps {
  selectedRows: any;
  onApprove: () => void;
  onReject: () => void;
  label: string;
  className?: string;
  btnLabel?: string;
  btnLabel2?: string;
  showBtnInitial?: boolean;
  showBtnSecond?: boolean;
}

const BulkActionBar: React.FC<BulkActionBarProps> = ({
  selectedRows,
  onApprove,
  onReject,
  label,
  className,
  btnLabel,
  btnLabel2,
  showBtnInitial = true,
  showBtnSecond = true,
}) => {
  if (!selectedRows || selectedRows.length === 0) return null;

  return (
    <div
      className={`position-absolute top-0 d-flex justify-content-between align-items-center ${className}`}
    >
      <P className="m-0 f-16">{label}</P>
      <div className="d-flex ms-4">
        {showBtnInitial && (
          <Btn color="primary" onClick={onApprove}>
            {btnLabel ? btnLabel : "Approve"}
          </Btn>
        )}
        {showBtnSecond && (
          <Btn color="danger" className="ms-3" onClick={onReject}>
            {btnLabel2 ? btnLabel2 : "Reject"}
          </Btn>
        )}
      </div>
    </div>
  );
};

export default BulkActionBar;
